<template>
  <v-container fill-height>
    <v-layout>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-icon
              medium
              left>
              alternate_email
            </v-icon>
            <span class="title">Data Kodepos</span>
          </v-card-title>
          <v-tabs
            v-model="tabdata"
            :background-color="maincolor"
            centered
            dark
            icons-and-text
            show-arrows>
            <v-tabs-slider color="pink"></v-tabs-slider>
            <v-tab href="#tab-list">
              Kodepos
              <v-icon large>alternate_email</v-icon>
            </v-tab>
            <v-tab href="#tab-addnew">
              Buat Baru
              <v-icon large>library_add</v-icon>
            </v-tab>
          </v-tabs>
          <v-tabs-items :touchless="true" v-model="tabdata">
            <v-tab-item value="tab-list">
              <v-card flat>
                <v-card-text>
                  <v-container>
                    <v-row justify="center">
                      <v-col cols="12" md="4">
                        <v-select
                          :items="liststatus"
                          name="statuspos"
                          v-model="filter.status"
                          label="Status"
                          @change="getKodepos">
                        </v-select>
                      </v-col>
                      <v-col cols="12" md="8">
                        <v-text-field
                          v-model="filter.search"
                          append-icon="search"
                          label="Search"
                          single-line
                          hide-details>
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <div class="text-center" v-if="loading.getdata">
                          <v-progress-circular
                            :width="3"
                            color="red"
                            indeterminate>
                          </v-progress-circular>
                        </div>
                        <v-data-table
                          :headers="headers"
                          :items="datalist"
                          :search="filter.search">
                          <template v-slot:[`item.action`]="{ item }">
                            <v-btn
                              @click="editKodepos(item)"
                              small
                              icon>
                              <v-icon>edit</v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item value="tab-addnew">
              <v-card flat>
                <v-card-text>
                  <v-container>
                    <v-form
                      @submit.prevent="submitAdd"
                      ref="formaddkodepos"
                      v-model="formadd.valid"
                      lazy-validation>
                      <v-row justify="center" no-gutters>
                        <v-col cols="12" sm="8" md="6">
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                v-model="addkodepos.kodepos"
                                :rules="[rules.required]"
                                label="Kode Pos"
                                name="kodepos"
                                required>
                              </v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                v-model="addkodepos.kelurahan"
                                :rules="[rules.required]"
                                label="Kelurahan"
                                name="kelurahan"
                                required>
                              </v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                v-model="addkodepos.kecamatan"
                                :rules="[rules.required]"
                                label="Kecamatan"
                                name="kecamatan"
                                required>
                              </v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                v-model="addkodepos.kabupaten"
                                :rules="[rules.required]"
                                label="Kabupaten"
                                name="kabupaten"
                                required>
                              </v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                v-model="addkodepos.provinsi"
                                :rules="[rules.required]"
                                label="Provinsi"
                                name="provinsi"
                                required>
                              </v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-select
                                :items="liststatus"
                                name="statuspos"
                                v-model="addkodepos.statuspos"
                                label="Status">
                              </v-select>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <alertsp :alertdata="alertdata"></alertsp>
                              <div class="text-center" v-if="loading.addkode">
                                <v-progress-circular
                                  :width="3"
                                  color="red"
                                  indeterminate>
                                </v-progress-circular>
                              </div>
                              <v-btn
                                v-if="!loading.addkode"
                                large
                                block
                                :disabled="!formadd.valid"
                                color="success"
                                class="mr-4 mt-5"
                                type="submit">
                                Simpan
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- modal - update -->
    <v-dialog
      v-model="dmodal.kodepos"
      max-width="600px"
      v-if="dmodaldata.kodepos">
      <v-card>
        <v-card-title>
          <span class="headline ma-auto">Update jenis pekerjaan</span>
        </v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md class="pa-0">
            <alertsp :alertdata="alertupdate"></alertsp>
            <v-form
              @submit.prevent="submitUpdate"
              ref="formupdatekodepos"
              v-model="formupdate.valid"
              lazy-validation>
              <v-row justify="center" no-gutters>
                <v-col cols="12">
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="dmodaldata.kodepos.kodepos"
                        :rules="[rules.required]"
                        label="Kode Pos"
                        name="kodepos"
                        required>
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="dmodaldata.kodepos.kelurahan"
                        :rules="[rules.required]"
                        label="Kelurahan"
                        name="kelurahan"
                        required>
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="dmodaldata.kodepos.kecamatan"
                        :rules="[rules.required]"
                        label="Kecamatan"
                        name="kecamatan"
                        required>
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="dmodaldata.kodepos.kabupaten"
                        :rules="[rules.required]"
                        label="Kabupaten"
                        name="kabupaten"
                        required>
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="dmodaldata.kodepos.provinsi"
                        :rules="[rules.required]"
                        label="Provinsi"
                        name="provinsi"
                        required>
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-select
                        :items="liststatus"
                        name="statuspos"
                        v-model="dmodaldata.kodepos.statuspos"
                        label="Status">
                      </v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" class="text-center">
                      <div class="text-center" v-if="loading.editkode">
                        <v-progress-circular
                          :width="3"
                          color="red"
                          indeterminate>
                        </v-progress-circular>
                      </div>
                      <v-btn
                        large
                        color="error"
                        class="mr-4 mt-5"
                        @click="closeDmodal('kodepos')">
                        Cancel
                      </v-btn>
                      <v-btn
                        v-if="!loading.editkode"
                        large
                        :disabled="!formupdate.valid"
                        color="success"
                        class="mr-4 mt-5"
                        type="submit">
                        Simpan
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'KodeposAdmin',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      getdata: false,
      addkode: false,
      editkode: false,
    },
    api: process.env.VUE_APP_API,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    liststatus: ['active', 'passive'],
    filter: {
      search: '',
      status: 'active',
    },
    headers: [
      { text: 'Kode Pos', value: 'kodepos' },
      { text: 'Kelurahan', value: 'kelurahan' },
      { text: 'Kecamatan', value: 'kecamatan' },
      { text: 'Kabupaten', value: 'kabupaten' },
      { text: 'Provinsi', value: 'provinsi' },
      { text: 'Status', value: 'statuspos' },
      { text: 'Actions', value: 'action', sortable: false, align: 'center' },
    ],
    datalist: [],
    addkodepos: {
      kodepos: '',
      kelurahan: '',
      kecamatan: '',
      kabupaten: '',
      provinsi: '',
      statuspos: 'active',
    },
    formadd: {
      password: false,
      valid: false,
    },
    formupdate: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => (v) && v.length >= 8 || 'Min 8 characters',
      nik: (v) => (v) && v.length >= 16 || 'Min 16 characters',
    },
    tabdata: null,
    dmodal: {
      kodepos: false,
    },
    dmodaldata: {
      kodepos: null,
    },
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  mounted() {
    this.getKodepos();
  },
  filters: {
    dateToAge(value) {
      return value;
    },
  },
  methods: {
    getKodepos() {
      if (this.tokenscr) {
        this.loading.getdata = true;
        this.axios
          .get(
            this.api + '/api/kodepos/',
            {
              params: {
                status: this.filter.status,
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.datalist = resdata.data;
              }
            }
            this.loading.getdata = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.getdata = false;
          });
      }
    },
    submitAdd() {
      this.alertdata.show = false;
      if (this.$refs.formaddkodepos.validate()) {
        if (this.tokenscr) {
          this.loading.addkode = true;
          this.axios
            .post(
              this.api + '/api/kodepos/',
              qs.stringify(
                this.addkodepos,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.$refs.formaddkodepos.reset();
                  this.alertdata.show = true;
                  this.alertdata.type = 'success';
                  this.alertdata.text = 'Kode pos "' + resdata.data + '" berhasil ditambahkan!';
                  this.getKodepos();
                } else {
                  this.alertdata.show = true;
                  this.alertdata.type = 'error';
                  this.alertdata.text = resdata.message;
                }
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = 'Internal services error!';
              }
              this.loading.addkode = false;
            })
            .catch((error) => {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
              this.loading.addkode = false;
            });
        } else {
          this.alertdata.show = true;
          this.alertdata.type = 'error';
          this.alertdata.text = 'Invalid token!';
        }
      }
    },
    closeDmodal(type) {
      if (type === 'kodepos') {
        this.dmodal.kodepos = false;
      } else {
        this.dmodal.kodepos = false;
      }
    },
    editKodepos(item) {
      this.alertupdate.show = false;
      this.dmodal.kodepos = true;
      this.dmodaldata.kodepos = JSON.parse(JSON.stringify(item));
    },
    submitUpdate() {
      this.alertupdate.show = false;
      if (this.$refs.formupdatekodepos.validate()) {
        if (this.tokenscr) {
          this.loading.editkode = true;
          this.axios
            .put(
              this.api + '/api/kodepos/',
              qs.stringify(
                this.dmodaldata.kodepos,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  // tslint:disable-next-line:max-line-length
                  this.alertupdate.text = this.dmodaldata.kodepos.kodepos + '" berhasil diubah!';
                  this.getKodepos();
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
              this.loading.editkode = false;
            })
            .catch((error) => {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
              this.loading.editkode = false;
            });
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
